import { render } from "./replace.vue?vue&type=template&id=381c4ab6"
import script from "./replace.vue?vue&type=script&lang=js"
export * from "./replace.vue?vue&type=script&lang=js"

import exportComponent from "/data/build/bruenor/tmp-docuseal/webpack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__